import styled from "styled-components";

export const StyledWrapper = styled.div`
  padding: 2rem;
  background-color: #000000;
`;
